export const decodeAppleToken = (token: string) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Error decoding Apple token:", error);
    return null;
  }
};

export const waitAppleID = (timeout = 5000): Promise<void> => {
  return new Promise((resolve, reject) => {
    if ((window as any).AppleID) {
      resolve();
      return;
    }

    const start = Date.now();
    const interval = setInterval(() => {
      if ((window as any).AppleID) {
        clearInterval(interval);
        resolve();
      } else if (Date.now() - start > timeout) {
        clearInterval(interval);
        reject(new Error("AppleID SDK not loaded"));
      }
    }, 100);
  });
};
